import { css } from '@emotion/react';
import styled from '@emotion/styled';

const TextStyles = css`
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
`;

const RatingBarWrapper = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr auto;
  gap: ${({ theme }) => theme.spacing[20]};
  align-items: center;
`;

const RatingBarLabel = styled.span<{ hasNoValue: boolean }>`
  display: flex;
  align-items: center;
  margin-right: ${({ theme }) => theme.spacing[20]};
  color: ${({ theme, hasNoValue }) =>
    hasNoValue ? theme.colors.neutral.grey120 : theme.colors.neutral.grey160};
  ${TextStyles};
`;

const RatingBarChart = styled.data<{ value: number }>`
  display: block;
  border-radius: ${({ theme }) => theme.radius.sm};
  height: 0.5rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.neutral.grey40};
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    width: ${({ value }) => `${value}%`};
    height: 100%;
    background-color: ${({ theme }) => theme.colors.brand.green100};
  }
`;

const RatingBarCount = styled.data`
  color: ${({ theme }) => theme.colors.neutral.grey160};
  ${TextStyles};
`;

export { RatingBarWrapper, RatingBarLabel, RatingBarChart, RatingBarCount };
